import { z } from 'zod';
export const RfidCardSchema = z.object({
    _id: z.string(),
    tenant_id: z.string(),
    user_id: z.string().optional(),
    tag: z.string().min(1),
    label: z.string().min(1),
    is_active: z.boolean(),
    last_used: z.coerce.date().optional(),
    created_at: z.coerce.date(),
});
export const CreateRfidCardSchema = z.object({
    tag: z.string().min(1).max(50),
    label: z.string().min(1).max(100),
    user_id: z.string().optional(),
});
/**
 * RFID tag setup-type list: who set a tag up. Canonical here so the two
 * consumers share one source and cannot drift: the RfidCard model
 * (@evi/db) stores it on `registered_by_type`, and the registration-price
 * matrix (`rfid_pricing` settings, read by @evi/billing) keys the one-time
 * fee and payer off it. The 'operator' slot is still open on the pricing
 * side. Values, not order, are the contract; consumers test membership.
 */
export const RFID_SETUP_TYPES = [
    'internal',
    'tenant_admin',
    'building_admin',
    'third_party',
    'fleet',
    'operator',
    // Driver-initiated self-registration (tap capture in the driver
    // app). The only channel where the DRIVER is the initiator, so the
    // only one that stays driver-pays under the whoever-initiates-pays
    // rule; its pricing entry also carries the per-tenant `enabled`
    // policy flag.
    'self_service',
];
//# sourceMappingURL=rfid.js.map